<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4>
                  Manage resource category
                </h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard </router-link>\   Resource category
                </div>
              </div>
              <div class="breadcrumb-right">
                <v-btn @click="addCategory()"
                       class="mt-4 btn btn-primary  mr-1"
                       dark>
                  <i class="fa fa-plus"></i>
                  Add category
                </v-btn>

              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="search-wrapper border-outline mb-5 px-3 py-5 d-sm-flex justify-content-start">
              <div class="row">
                <div class="col-6">
                  <v-text-field label="Title" clearable
                                type="text"
                                dense v-on:keyup.enter="getResources"
                                outlined
                                v-model="search.title"></v-text-field>
                </div>
                <div class="col-4">
                  <v-select v-on:keyup.enter="getResources" label="Status" outlined dense :items="active_statuses" item-text="title"
                            item-value="value"
                            v-model="search.active"></v-select>
                </div>

                <v-col cols="2" md="2" class="text-right">
                  <v-btn
                      @click="getResources()"
                      class="btn btn-primary btn-search "
                      :loading="loading"
                  >
                    <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                    Search
                  </v-btn>
                </v-col>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-stripe">
                <thead>
                  <tr class="px-3">
                    <th>Title</th>
                    <th>Status</th>
                    <th class="pr-3 text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="(category, i) of categories" :key="i">
                  <td>
                    <a href="#" @click="editCategory(category)" class="mr-2"> {{ category.title }}</a>

                  </td>
                  <td>
                    <span class="badge badge-success text-lg`" v-bind:class="{ 'badge-success': category.is_active, 'badge-danger': !category.is_active }">
                      {{ category.is_active ? 'Active' : 'Inactive' }}
                    </span>
                  </td>
                  <td class="pr-0 text-center">
                    <b-dropdown
                        size="sm"
                        variant="link"
                        toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        no-caret
                        right
                        no-flip
                    >
                      <template v-slot:button-content>
                        <slot>
                                                            <span>
                                                                        <i class="flaticon-more-1"></i>
                                                                      </span></slot>
                      </template>
                      <!--begin::Navigation-->
                      <div class="navi navi-hover ">

                        <b-dropdown-text tag="div" class="navi-item">
                          <a href="#" class="navi-link"
                             @click="editCategory(category)">
                                                                <span class="navi-icon">
                                                                  <i class="flaticon-edit"></i>
                                                                </span>
                            <span class="navi-text">  Edit</span>
                          </a>
                        </b-dropdown-text>
                        <b-dropdown-text tag="div" class="navi-item">
                          <a href="#" class="navi-link"
                             @click="deleteCategory(category.id)">
                                                                <span class="navi-icon">
                                                                  <i class="fas fa-trash"></i>
                                                                </span>
                            <span class="navi-text">  Delete</span>
                          </a>
                        </b-dropdown-text>

                      </div>
                      <!--end::Navigation-->
                    </b-dropdown>

                  </td>
                </tr>
                <tr  v-if="categories.length == 0">
                  <td class="px-3 text-center" colspan="3">
                    <strong>No items found.</strong>
                  </td>
                </tr>
                </tbody>
              </table>
              <b-pagination
                  class="pull-right mt-7"
                  :disabled="loading"
                  v-if="categories.length > 0"
                  @input="getResources"
                  v-model="page"
                  :total-rows="total"
                  :per-page="perPage"
                  first-number
                  last-number
              ></b-pagination>
            </div>

          </div>
        </div>
      </div>
    </div>
    <create-and-update ref="category" @refresh="getResources"></create-and-update>
  </v-app>
</template>
<script>
import CreateAndUpdate from "./CreateAndUpdate"
import CategoryService from "@/core/services/library/resource/CategoryService";

const resourceCategoryService = new CategoryService();

export default {
  name: "Index",
  components: {CreateAndUpdate},
  data() {
    return {
      search: {
        title:'',
        active:'',
      },
      categories: [],
      dialog: false,
      loading: false,
      page: 1,
      total: null,
      perPage: null,
      active_statuses: [
        {title: 'Active', value: "active"},
        {title: 'Inactive', value: "in_active"}
      ],
    }
  },
  mounted() {
    this.getResources()
  },
  methods: {
    getResources() {
      this.loading=true;
      resourceCategoryService.
        paginate(this.search)
          .then(response => {
            this.categories = response.data.data
            this.page = response.data.meta.current_page;
            this.total = response.data.meta.total;
            this.perPage = response.data.meta.per_page;
        })
          .catch((err) => {
            console.log(err)
          })
          .finally(()=>{
            this.loading=false;
          });
    },
    deleteCategory(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            resourceCategoryService.delete(id).then(response => {
              this.getResources();
            })
          }
        }
      });
    },
    deleteRack(shelfId, id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            resourceCategoryService.delete(shelfId, id).then(response => {
              this.$snotify.success("Category deleted successfully")
              this.getResources();
            })
          }
        }
      });
    },
    addCategory() {
      this.$refs['category'].createCategory();
    },
    editCategory(category) {
      this.dialog = true
      this.$refs['category'].editCategory(category)
    },
    closeDialog() {
      this.dialog = false
      this.getResources();
    }
  }
}
</script>

<style scoped>
</style>